var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Loader, Menu, useToast } from '@pocketlaw/tetris';
import { useHistory } from 'react-router-dom';
import { useCreateDraft } from 'app/domains/templates';
import { Flag } from 'shared/domains/languages';
import { getCurrentMarket } from 'shared/domains/markets/config';
import { useGtm } from 'shared/domains/tracking';
import { useComposer } from './useComposer';
export function CreateButton(props) {
    var _a;
    const { composerId, disabled } = props;
    const { getComposer, loading, data } = useComposer(composerId);
    const [creatingDraft, setCreatingDraft] = useState(false);
    const createDraft = useCreateDraft();
    const { addToast } = useToast();
    const { push: gtmPush } = useGtm();
    const history = useHistory();
    const templates = ((_a = data === null || data === void 0 ? void 0 : data.composer) === null || _a === void 0 ? void 0 : _a.templates) || [];
    const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
    const currentMarket = getCurrentMarket();
    const handleConfirmLanguage = (composer, template) => __awaiter(this, void 0, void 0, function* () {
        var _b;
        setCreatingDraft(true);
        const version = template === null || template === void 0 ? void 0 : template.latestVersion;
        try {
            const { data: createDraftData } = yield createDraft.mutate({
                composerId,
                templateId: template === null || template === void 0 ? void 0 : template.id,
                version: (_b = composer === null || composer === void 0 ? void 0 : composer.tree) === null || _b === void 0 ? void 0 : _b.version,
                templateVersionTemplateId: version === null || version === void 0 ? void 0 : version.templateId,
                templateVersionReference: version === null || version === void 0 ? void 0 : version.reference,
            });
            gtmPush({
                event: 'template_start',
                form: template === null || template === void 0 ? void 0 : template.id,
            });
            const { id } = (createDraftData === null || createDraftData === void 0 ? void 0 : createDraftData.created) || {};
            const newId = id || '';
            history.push(`/draft/${newId}`);
        }
        catch (_c) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'An error occurred',
                    comment: 'Error message displayed in composer/template dialog when creating a draft',
                }),
            });
            setCreatingDraft(false);
        }
    });
    const fetchLanguages = () => __awaiter(this, void 0, void 0, function* () {
        var _d, _e, _f;
        try {
            const result = yield getComposer();
            const availableTemplates = ((_e = (_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.composer) === null || _e === void 0 ? void 0 : _e.templates) || [];
            if (availableTemplates.length === 0) {
                throw new Error('No templates found for this composer.');
            }
            if (availableTemplates.length === 1) {
                // No need to let user "choose" language if there is only one language available, create draft right away
                handleConfirmLanguage((_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.composer, availableTemplates[0]);
            }
            else {
                setLanguageMenuOpen(true);
            }
        }
        catch (_g) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'An error occurred',
                    comment: 'Error message displayed in composer/template dialog when creating a draft',
                }),
            });
        }
    });
    const handleSelectTemplate = (template) => {
        handleConfirmLanguage(data === null || data === void 0 ? void 0 : data.composer, template);
    };
    if (creatingDraft || templates.length < 2) {
        return (<Button $stretch size="small" type="button" appearance="primary" onClick={fetchLanguages} disabled={disabled || loading || creatingDraft}>
        {(loading || creatingDraft) && <Loader />}
        <Trans comment="template card hover button: create template">Use</Trans>
      </Button>);
    }
    return (<Menu.Root target={<Button $stretch size="small" type="button" appearance="primary" disabled={disabled}>
          <Trans comment="template card hover button: create template">Use</Trans>
        </Button>} onClose={() => setLanguageMenuOpen(false)} open={languageMenuOpen && templates.length > 1}>
      <Menu.Header title={t({
            message: 'Choose language',
            comment: 'template card: create-button popover menu title',
        })}/>
      {templates.map((template) => {
            const languageCode = template.marketLocale.code;
            const locale = currentMarket.templateLocales.find((templateLocale) => templateLocale.languageCode === languageCode);
            return (<Menu.Item key={template.id} onClick={() => handleSelectTemplate(template)}>
            <Flag languageCode={languageCode}/>
            {locale === null || locale === void 0 ? void 0 : locale.getName()}
          </Menu.Item>);
        })}
    </Menu.Root>);
}
